import React from "react";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { __ } from "services/Translator";
import Slider from "react-slick";
import api from "services/api";

export default function WelcomePromotions(props) {
  const gamesSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    autoplay: false,
    autoplaySpeed: 5000,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          className: "center",
          centerMode: true,
        },
      },
    ],
  };

  //Get Promotion functionality
  const [promotions, setPromotions] = useState([]);
  const [firstPromotion, setFirstPromotion] = useState([]);
  const getPromotions = async (page) => {
    props.setSpinner(true);
    var response = await api.get("/promotions", {
      promotion_type: "Welcome",
    });
    props.setSpinner(false);
    if (response.status === 200) {
      setPromotions(response.data.promotions);
      setFirstPromotion(response.data.promotions.shift());
    }
  };

  useEffect(() => {
    getPromotions();
  }, []);

  return (
    <section className="fetured_bonus">
      <div className="container-lg">
        <div className="row align-items-center">
          <div className="col-12 col-md-5 col-lg-5 col-xl-5 col-xxl-4">
            <div className="fetured_turnament_block">
              <img alt="game image" src={firstPromotion.image} />

              <div className="text_block">
                <div className="title italic">{__("Featured")}</div>
                <div className="title headline">{firstPromotion.title}</div>

                <div className="paragraph text-white">
                  {firstPromotion.subtitle}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-7 col-lg-7 col-xl-7 col-xxl-8">
            <div className="futured_right_block">
              <div className="row">
                <div className="col-12 col-md-8 col-lg-6 col-xl-7">
                  <div className="headline ">{__("Welcome Bonus")}</div>
                  <div className="paragraph padding_bottom_15">
                    {__(
                      "Sign up today and enjoy a huge welcome bonus package with cashback."
                    )}
                  </div>
                  {props.isAuthenticated ? (
                    <Link
                      to="/games/slots"
                      className={"angle_btn " + props.landingType}
                    >
                      {__("Play Now")}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="red"
                        class="bi bi-arrow-right"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                        />
                      </svg>
                    </Link>
                  ) : (
                    <Link
                      onClick={() => {
                        props.setModalSignUpPropsData(true);
                      }}
                      className={"angle_btn " + props.landingType}
                    >
                      {__("Sign Up Now")}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="red"
                        class="bi bi-arrow-right"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                        />
                      </svg>
                    </Link>
                  )}
                </div>
                <div className="col-12 col-md-4 col-lg-6 col-xl-5">
                  <img
                    alt="game image"
                    className="floatRight"
                    src="https://chimpbytes.imgix.net/fetured-card.png?&dpr=1&format=auto&auto=format&w=250&h=297&max-age=2629056"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  <div className="welcomePromotionSlider">
                    {promotions.length > 0 && (
                      <Slider {...gamesSettings}>
                        {promotions.map((item, index) => (
                          <div className="slickItem">
                            <div className="single_deposit_block ">
                              <img alt="game image" src={item.image} />

                              <div className="text_block">
                                <div className="title">{item.title}</div>
                                <div className="deposit_paragraph">
                                  {__("Hover for details")}
                                </div>
                              </div>

                              <div className="overley_content">
                                <div className="text_block">
                                  <div className="title">{item.title}</div>
                                  <div className="deposit_paragraph padding_bottom_15">
                                    {item.subtitle}
                                  </div>

                                  <Link>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="25"
                                      height="25"
                                      fill="white"
                                      class="bi bi-arrow-right"
                                      viewBox="0 0 16 16"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                                      />
                                    </svg>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                        {/* <div className="slickItem">
                          <div className="single_deposit_block ">
                            {props.landingType === "casino" && (
                              <img
                                alt="game image"
                                src="https://chimpbytes.imgix.net/fetured-item-home-bg.png?&dpr=1&format=auto&auto=format&w=526&h=744&max-age=2629056"
                              />
                            )}
                            {props.landingType === "poker" && (
                              <img
                                alt="game image"
                                src="https://chimpbytes.imgix.net/fetured-item-poker-bg.png?&dpr=1&format=auto&auto=format&w=526&h=744&max-age=2629056"
                              />
                            )}

                            {props.landingType === "sport" && (
                              <img
                                alt="game image"
                                src="https://chimpbytes.imgix.net/fetured-item-sport-bg.png?&dpr=1&format=auto&auto=format&w=526&h=744&max-age=2629056"
                              />
                            )}
                            {props.landingType === "bingo" && (
                              <img
                                alt="game image"
                                src="https://chimpbytes.imgix.net/fetured-item-bg.png?&dpr=1&format=auto&auto=format&w=526&h=744&max-age=2629056"
                              />
                            )}
                            <div className="text_block">
                              <div className="title">
                                {__("Second Deposit")}
                              </div>
                              <div className="deposit_paragraph">
                                {__("Hover for details")}
                              </div>
                            </div>

                            <div className="overley_content">
                              <div className="text_block">
                                <div className="title">
                                  {__("Second Deposit")}
                                </div>
                                <div className="deposit_paragraph">
                                  {__("Lorem ipsum dolor sit amet,")}
                                </div>
                                <div className="deposit_paragraph">
                                  {__("consectetur adipiscing elit, sed do")}
                                </div>
                                <div className="deposit_paragraph padding_bottom_15">
                                  {__("eiusmod tempor.")}
                                </div>
                                <Link to="#">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="25"
                                    height="25"
                                    fill="white"
                                    class="bi bi-arrow-right"
                                    viewBox="0 0 16 16"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                                    />
                                  </svg>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div> */}
                        {/* <div className="slickItem">
                          <div className="single_deposit_block ">
                            {props.landingType === "casino" && (
                              <img
                                alt="game image"
                                src="https://chimpbytes.imgix.net/fetured-item-home-bg.png?&dpr=1&format=auto&auto=format&w=526&h=744&max-age=2629056"
                              />
                            )}
                            {props.landingType === "poker" && (
                              <img
                                alt="game image"
                                src="https://chimpbytes.imgix.net/fetured-item-poker-bg.png?&dpr=1&format=auto&auto=format&w=526&h=744&max-age=2629056"
                              />
                            )}

                            {props.landingType === "sport" && (
                              <img
                                alt="game image"
                                src="https://chimpbytes.imgix.net/fetured-item-sport-bg.png?&dpr=1&format=auto&auto=format&w=526&h=744&max-age=2629056"
                              />
                            )}
                            {props.landingType === "bingo" && (
                              <img
                                alt="game image"
                                src="https://chimpbytes.imgix.net/fetured-item-bg.png?&dpr=1&format=auto&auto=format&w=526&h=744&max-age=2629056"
                              />
                            )}
                            <div className="text_block">
                              <div className="title">{__("Third Deposit")}</div>
                              <div className="deposit_paragraph">
                                {__("Hover for details")}
                              </div>
                            </div>

                            <div className="overley_content">
                              <div className="text_block">
                                <div className="title">
                                  {__("Third Deposit")}
                                </div>
                                <div className="deposit_paragraph">
                                  {__("Lorem ipsum dolor sit amet,")}
                                </div>
                                <div className="deposit_paragraph">
                                  {__("consectetur adipiscing elit, sed do")}
                                </div>
                                <div className="deposit_paragraph padding_bottom_15">
                                  {__("eiusmod tempor.")}
                                </div>
                                <Link to="#">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="25"
                                    height="25"
                                    fill="white"
                                    class="bi bi-arrow-right"
                                    viewBox="0 0 16 16"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                                    />
                                  </svg>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div> */}
                      </Slider>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
